var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingExpiredClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333ZM7.36111 3.33333C7.36111 2.9498 7.0502 2.63889 6.66667 2.63889C6.28314 2.63889 5.97222 2.9498 5.97222 3.33333V6.66667C5.97222 6.85084 6.04539 7.02748 6.17562 7.15771L8.53265 9.51473C8.80384 9.78593 9.24354 9.78593 9.51474 9.51473C9.78594 9.24354 9.78594 8.80384 9.51474 8.53264L7.36111 6.37902V3.33333Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingExpiredClock);
export default __webpack_public_path__ + "static/media/onboarding-expired-clock.b1854cdeeb1612dc8ac8cc7face80f4a.svg";
export { ForwardRef as ReactComponent };